import React from 'react';
import { Modal } from '@grofers/dock-design-kit';

/**
 * Small "Are you sure?" confirmation dialog, built directly on top of
 * dock-design-kit's own `Modal` (headerProps/actionPanelProps) rather than
 * the older `UiKit` Modal/Confirm, since the Figma spec
 * (node 2311-58960, 2704-38839) is styled with dock's own panel-header/
 * action-panel tokens, not the legacy sushiweb-era modal.
 *
 * `message` is a full JSX node (not split into title/description) since the
 * design renders one sentence with an inline bold clause, not two separate
 * lines.
 */
const ConfirmationModal = ({
  isOpen = false,
  message = null,
  onCancel = () => {},
  onConfirm = () => {},
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    size='sm'
    headerProps={{ title: message }}
    actionPanelProps={{
      secondaryAction: { label: 'No, Go Back', onClick: onCancel },
      primaryAction: { label: 'Yes, Proceed', onClick: onConfirm },
    }}
  />
);

export default ConfirmationModal;
